<div class="logout-page-container">
  <p>You have been logged out.</p>
</div>
